import Typeahead from './Typeahead.js';
export default Typeahead;
//# sourceMappingURL=index.js.map